import API from "../../api";

export const getAudits = policy_number =>
  API.agent().get(`/audits?policy_number=${policy_number}`);

export const getAuditDocument = (policy_number, id_number) =>
  API.agent().get(`/audits/${id_number}?policy_number=${policy_number}`, {
    responseType: "blob"
  });
